<template>
<div class>
		<!-- <div class="fixed-header w-full"> -->
<TopAppBar
	:leftBtnMode="leftBtnMode"
	:rightBtnMode="rightBtnMode"
	:title="topTitle"
	:leftBtnMethod="leftBtnMethod"
	:rightBtnMethod="rightBtnMethod"
  :hideCategory="false"
	staticMode="true"
></TopAppBar>
<div class="d-flex flex-column "  :class="isNoData ? 'vh-100' : 'h-full'">
	<TopAppBarDrawer></TopAppBarDrawer>
	<main class="main-wrapper flex-grow-1">
		<div class="d-flex align-items-center">
			<div class="t-headline13 t-color-headlineBlack pda-14 t-center font-m flex-grow-1 fix-header-title d-flex justify-content-center align-items-center">
				{{title}}
			</div>
		</div>
		<div class="divider"></div>
				<!-- subtabs -->
			<NoData v-if="isNoData"></NoData>
			<div class="container container--narrow pdt-30 mgb-50" v-else>
				<div class="mdc-card  mgb-24 pda-24 cursor-pointer"
						v-for="(lesson, index) in listData"
						:key="index"
						tabindex="0" @click="moveToLessonList(lesson.learnerId,lesson.lessonId,lesson.progressionId,lesson.isPossibleLearning,lesson.userExposure,lesson.marketCode.key)"
						@keypress="moveToLessonList(lesson.learnerId,lesson.lessonId,lesson.progressionId,lesson.isPossibleLearning,lesson.userExposure,lesson.marketCode.key)"
						>
					<!-- Add 스킬패스 / 온라인 클래스 -->
					<div class="t-color-bodyGrayA t-helper">
						{{ lesson.marketCode.key === "ONLINE" ? $t("3756") : $t("3755") }}
					</div>

					<div class="t-subtitle5 font-m  mgb-16 t-line-1">{{lesson.degreeName}}</div>
						<div class="d-flex position-relative">
							<div class="">
								<img src="../../images/test.svg" alt=""  v-if="lesson.contentsType.value === 'EXAM_PAPER'" class="w-40 h-40">
									<img src="../../images/study.svg" alt=""  v-else
									class="w-40 h-40">
								<div class="h-2 position-relative total-percentage-course mgt-8 mgb-6 bg-iconinactiveText">
												<div class="real-percentage bg-bodyBlueGray h-2 " :style="`width:${lesson.rate}%;`"></div>
								</div>
								<div class="t-body3 t-color-bodyBlueGray t-center font-r">{{$t('1838',{str:parseInt(lesson.rate)})}}</div>
							</div>
							<div class="flex-grow-1 pdl-20">
								<div class="">
									<div class="t-body1 mgb-4  font-r pdr-24 l-spacing48 t-line-1">
													{{lesson.name}}
									</div>
									<div class="t-body6  font-r pdr-24 l-spacing45 t-color-bodyGrayA"
									v-if="lesson && lesson.contentsType && lesson.contentsType.value=='VIDEO' && lesson.rate==100"
									>
												{{$t('1845')}}
									</div>
								<div class="t-body6  font-r pdr-24 l-spacing45 t-color-bodyGrayA"
									v-else-if="lesson && lesson.contentsType && lesson.contentsType.value=='VIDEO' && lesson.rate!=100"
									>
												{{$t('1839')}}
									</div>
								<div class="t-body6  font-r pdr-24 l-spacing45 t-color-bodyGrayA"
									v-else-if="lesson && lesson.contentsType && lesson.contentsType.value=='PDF'"
									>
												{{$t('1841')}}
									</div>
								<div class="t-body6  font-r pdr-24 l-spacing45 t-color-bodyGrayA"
								     v-else-if="lesson && lesson.contentsType && lesson.contentsType.value === 'HTML'"
									>
													{{$t('1842')}}
									</div>
									<div class="t-body6  font-r pdr-24 l-spacing45 t-color-bodyGrayA"
									     v-else-if="lesson && lesson.contentsType && lesson.contentsType.value === 'INTERACTIVE_HTML'"
									>
										{{$t('3763')}}
									</div>
									<div class="t-body6  font-r pdr-24 l-spacing45 t-color-bodyGrayA"
									     v-else-if="lesson && lesson.contentsType && lesson.contentsType.value === 'CEGOS'"
									>
										{{$t('4830')}}
									</div>
								<div class="t-body6  font-r pdr-24 l-spacing45 t-color-bodyGrayA"
									v-else
									>
													{{$t(lesson.contentsType.translate)}}
									</div>
								</div>
							</div>
						</div>
						</div>
						<infinite-loading  @infinite="fetchData" :identifier="infiniteId" spinner="spiral">
							<div slot="no-more" class="mgt-16"></div>
							<div slot="no-results" class="mgt-16"></div>
            </infinite-loading>
					</div>
			</main>
	</div>
	</div>
</template>

<script>

// Components/Mixin/Extend/API define
import TopAppBar from '@/components/TopAppBar.vue'
import {topAppBarMixin} from '@/mixins/topAppBar.js'
import { MDCRipple } from "@material/ripple";
import { fileMixin } from "@/mixins/file.js";
import portfolioApi from "@/api/portfolioApi.js";
import NoData from "../common/NoDataBookMarkedLesson.vue";
import InfiniteLoading from "vue-infinite-loading";
import TopAppBarDrawer from "../TopAppBarDrawer.vue";

export default {
	components: {
		NoData,
		InfiniteLoading,
		TopAppBar,
		TopAppBarDrawer
	},

	filters: {
    charLength(value) {
      if(value.length>30) {
        return value.substring(0,30)+".."
      } else {
        return value
      }
    },
	},

	data() {
		return {
			status: "",
			leftBtnMethod: () => { this.$router.go(-1)},
			isNoData: false,
			campaignData: null,
			listData: [],
			currentPage: 1,
			totalPages: 1,
			infiniteId: +new Date(),
			topTitle: localStorage.getItem('brandName')
		};
	},

	mixins: [topAppBarMixin,fileMixin],

	computed: {},

	watch: {
		$route(to, from) {
			this.initData();
		},
	},

	mounted() {
		// 기본 파라미터 설정(set default parameter)
		this.setTopAppBarBackPortfolio(this.$t('1837'))
	},

	methods: {
		initData() {
			this.listData = [];
			this.currentPage = 1;
			this.totalPages = 1;
			this.infiniteId += 1
		},
		// 목록 데이터 로딩(get list data)
		fetchData($state) {
			let responseData = null;
			let responseDatas = null;
			if (this.totalPages >= this.currentPage) {
				portfolioApi
					.bookMarkedLessonList()
					.then((response) => {
						responseData = response.data.data;
						responseDatas = response.data;
						this.listData = this.listData.concat(responseDatas.data);
						this.currentPage++;
						this.totalPages = responseData.totalPages;

						if (responseData.length) {
							$state.loaded();
						} else {
							$state.complete();
						}

						if (this.listData.length > 0) {
							this.isNoData = false;
						} else {
							this.isNoData = true;
						}
					})
					.catch((err) => {
						//$state.error();
					});
			} else {
				$state.complete();
			}
		},

		moveToLessonList(learnerId,lessonId,progressionId,isPossibleLearning,userExposure,type){
			if(isPossibleLearning===false){
				this.$alert({
					title: this.$t("1944"),
					content: this.$t("1945"),
					accept: this.$t("1946"),
					})
					.then(() => {
						//this.$router.push("/verificationcode");
					})
					.catch(() => {
						//this.$router.push('/login')
					});
			} else if(userExposure.value=='HIDED') {
				this.$alert({
					title: '',
					content: this.$t("3053"),
					accept: this.$t("3054"),
					})
					.then(() => {
						//this.$router.push("/verificationcode");
					})
					.catch(() => {
						//this.$router.push('/login')
					})
			} else {
				localStorage.setItem('bookMarkLesson','setGoBackBookMarkLesson')
				this.$router.push({
					name: type === "ONLINE" ? "LessonView" : "MicroDegreeLessonView",
					params: {
						learnId: learnerId,
						lessonId: lessonId,
						progressionId: progressionId
					},
					query: {
						status: 'LEARNING'
					},
				});
			}
    	}
	},
};
</script>
